import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { useQuery } from '@apollo/react-hooks';

import Loading from '../components/Loading/Loading';
import { queryCollectionProductsByHandle } from '../Queries';
import CollectionSlider from '../components/CollectionSlider/CollectionSlider';

var SliderPage = function SliderPage(props) {
  return ReactDOM.createPortal(React.createElement(SliderPageLoader, props), document.getElementById(props.sliderId));
};

var _ref = React.createElement(
  'div',
  { className: 'loading-wrapper' },
  React.createElement(Loading, null)
);

var SliderPageLoader = function SliderPageLoader(props) {
  var amount = 8;

  var _useQuery = useQuery(queryCollectionProductsByHandle, {
    variables: { handle: props.sliderCollection, amount: amount }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  if (loading || !data.collectionByHandle) return _ref;
  if (error) throw new Error(error);

  return React.createElement(CollectionSlider, {
    addVariantToCart: props.addVariantToCart,
    checkout: props.checkout,
    products: data.collectionByHandle.products.edges
  });
};

SliderPage.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  sliderId: PropTypes.string.isRequired,
  checkout: PropTypes.object.isRequired,
  sliderCollection: PropTypes.string.isRequired
};

SliderPageLoader.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  sliderId: PropTypes.string.isRequired,
  checkout: PropTypes.object.isRequired,
  sliderCollection: PropTypes.string.isRequired
};

export default SliderPage;